<div class="dialog-header">
  <h2 class="dialog-title">
    <mat-icon class="header-icon">cookie</mat-icon>
    <span class="title-text">Preferințe Cookie-uri</span>
  </h2>
  <button mat-icon-button mat-dialog-close class="close-button" aria-label="Închide">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>

<div class="dialog-content-wrapper">
  <div class="info-box">
    <mat-icon class="info-icon">info</mat-icon>
    <p class="info-text">
      Alege ce tipuri de cookie-uri dorești să accepți. Cookie-urile esențiale sunt necesare pentru funcționarea site-ului și nu pot fi dezactivate.
    </p>
  </div>

  <div class="cookie-intro">
    <p class="intro-text">
      Poți schimba aceste setări oricând din secțiunea de preferințe. Modificările tale vor fi salvate automat.
    </p>
  </div>

  <div class="categories-container">
    @for (category of categories(); track category.key) {
      <div class="category-card" [class.category-card--required]="category.required">
        <div class="category-header">
          <div class="category-info">
            <h3 class="category-title">
              {{ category.title }}
              @if (category.required) {
                <span class="required-badge">Obligatoriu</span>
              }
            </h3>
            <p class="category-description">{{ category.description }}</p>
          </div>
          
          <mat-slide-toggle
            class="category-toggle"
            [checked]="category.enabled"
            [disabled]="category.required"
            (change)="updatePreference(category.key, $event.checked)"
            color="primary"
            [attr.aria-label]="'Activează ' + category.title"
          >
          </mat-slide-toggle>
        </div>

        @if (category.details.length > 0) {
          <div class="category-details">
            <button 
              mat-button 
              class="details-toggle-button"
              (click)="toggleDetails(category.key)"
              [attr.aria-expanded]="showDetails()[category.key]"
            >
              <span class="details-toggle-text">
                {{ showDetails()[category.key] ? 'Ascunde detaliile' : 'Arată detaliile' }}
              </span>
              <mat-icon class="details-toggle-icon">
                {{ showDetails()[category.key] ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </button>
            
            @if (showDetails()[category.key]) {
              <ul class="details-list">
                @for (detail of category.details; track detail) {
                  <li class="details-item">
                    <mat-icon class="details-item-icon">check_circle</mat-icon>
                    <span class="details-item-text">{{ detail }}</span>
                  </li>
                }
              </ul>
            }
          </div>
        }
      </div>
      
      @if (!$last) {
        <div class="category-divider"></div>
      }
    }
  </div>
</div>

<div class="dialog-actions">
  <button 
    mat-button mat-stroked-button
    class="cancel-button"
    (click)="cancel()"
  >
    <span class="button-text">Anulează</span>
  </button>
  
  <button 
    mat-raised-button 
    color="primary"
    class="submit-button"
    (click)="savePreferences()"
  >
    <span class="button-text">Salvează preferințele</span>
    <mat-icon class="button-icon">check</mat-icon>
  </button>
</div>